import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import DotsLoading from '../../../../components/dotsLoading';
import SecondaryCard from '../../../../components/mazraeKit/cards/secondaryCard';
import {useGetNearestLabs} from '../../../../services/hookService/getNearestLabs/useGetNearestLabs';
import {useGetNearestStores} from '../../../../services/hookService/getNearestStores/useGetNearestStores';
import {RootState} from '../../../../store/redux';
import {googleAnalyticsInstance} from '../../../../utilities/helper/googleAnalitics';

const NearestStores = () => {
  const {locational} = useSelector(
    (state: RootState) => state.searchingLocation,
  );
  const cities = locational.map(item => item.id).join(',');

  const {nearestStores, nearestStoresIsLoading} = useGetNearestStores({
    page: 1,
    app: 'supplier',
    selected_cities_id: cities || undefined,
  });

  const {nearestLabs} = useGetNearestLabs({
    page: 1,
    selected_cities_id: cities || undefined,
  });

  const navigate = useNavigate();

  const combineLabsAndStores = [
    ...(nearestStores?.data?.results || []),
    ...(nearestLabs?.data?.results || []),
  ];

  return (
    <div className="flex flex-col w-full gap-2 px-3">
      <div className="flex items-center justify-between w-full">
        <h5 className="flex items-center p-0 m-0 text-gray-700 text-md">
          فروشگاه های مزرعه{' '}
        </h5>
        <button
          className="flex items-center text-sm text-farm-shop-500"
          onClick={() => {
            navigate('/shop-listing');
            googleAnalyticsInstance.eventGoogleAnalytics({
              category: 'AllNeareststores',
              action:
                'رو مشاهده همه فروشندگان نزدیک من در صفحه هوم شاپ کلیک شد',
            });
          }}
        >
          مشاهده همه
          <SpanIcon className="text-lg icon-nameArrow---Left-2" />
        </button>
      </div>

      {nearestStoresIsLoading ? (
        <DotsLoading />
      ) : (
        combineLabsAndStores && (
          <div className="w-full flex gap-2 h-[170px] items-center overflow-x-auto ">
            {combineLabsAndStores?.map((item: IResults, index) => {
              return (
                <SecondaryCard
                  rate={item.average_rate}
                  key={index}
                  logo={item.logo}
                  title={item.title}
                  state={item?.state?.name || ''}
                  city={item?.city?.name || ''}
                  input_groups={
                    item?.store_type
                      ? item?.store_type.input_groups
                      : item.lab_field
                  }
                  guid={item.guid}
                  cardWrapperClassName="!h-[112px]"
                  onClick={() =>
                    item?.store_type
                      ? navigate(`/shop-card-detail/${item.guid}`)
                      : navigate(`/lab-card-detail/${item.guid}`)
                  }
                />
              );
            })}
          </div>
        )
      )}
    </div>
  );
};

export default NearestStores;
